<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Event" childName="Sponsors"></side-menu>

    <div class="content">
      <div class="dashboard">
        <heading v-if="event" :title="'Sponsors'"></heading>

        <button @click="openPopup" class="btn">
          <img class="white_icon" src="@/assets/img/plus.svg" />Add Sponsor
        </button>

        <div class="sponsors">
          <div class="card" v-for="sponsor in sponsors" :key="sponsor.id">
            <div
              class="image"
              :style="{ backgroundImage: 'url(' + sponsor.logo + ')' }"
            ></div>
            <p class="name">{{ sponsor.name }}</p>
            <p class="url">{{ sponsor.url }}</p>
            <p class="description">{{ sponsor.description }}</p>
            <div class="controls">
              <img
                @click="deleteSponsor(sponsor.id)"
                src="@/assets/img/trash.svg"
              />
              <img
                @click="editSponsor(sponsor)"
                src="@/assets/img/settings.svg"
              />
            </div>
          </div>
        </div>

        <popup title="Add a Sponsor" :show="showPopup">
          <div class="inputs">
            <div class="left">
              <div class="input">
                <label>Sponsor Logo</label>
                <upload
                  title="Logo"
                  :media="sponsor.logo"
                  @addMedia="addMedia($event, 'logo')"
                  @removeImage="sponsor.logo = null"
                ></upload>
              </div>
            </div>

            <div class="right">
              <div class="input">
                <label>Name</label>
                <input type="text" v-model="sponsor.name" />
              </div>

              <div class="input">
                <label>Company Website</label>
                <input type="text" v-model="sponsor.url" />
              </div>

              <div class="input">
                <label>Description</label>
                <textarea
                  draggable="no"
                  v-model="sponsor.description"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="btns">
            <button @click="closePopup" class="btn text_btn">Cancel</button>
            <button @click="addSponsor" class="btn">Save</button>
          </div>
        </popup>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";
import Upload from "@/components/Upload.vue";
import Popup from "@/components/Popup.vue";
import Swal from "sweetalert2";
import { Datetime } from "vue-datetime";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "sponsors",
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    datetime: Datetime,
    heading: Title,
    popup: Popup,
    upload: Upload,
  },
  data() {
    return {
      event: null,
      showPopup: false,
      init_edit: false,
      sponsors: [],
      sponsor: {
        created_at: Date.now(),
        logo: null,
        url: null,
        description: null,
        name: null,
      },
    };
  },
  firestore() {
    return {
      event: db.collection("event").doc(this.$route.params.id),
      sponsors: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("sponsors"),
    };
  },
  computed: {},
  methods: {
    addMedia(url, key) {
      this.sponsor.logo = url;
    },
    openPopup() {
      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
      this.init_edit = false;
      this.sponsor = {
        created_at: Date.now(),
        logo: null,
        url: null,
        description: null,
        name: null,
      };
    },
    addSponsor() {
      let sponsor = this.sponsor;
      let sponsorRef = !this.init_edit
        ? db
            .collection("event")
            .doc(this.$route.params.id)
            .collection("sponsors")
            .doc()
        : db
            .collection("event")
            .doc(this.$route.params.id)
            .collection("sponsors")
            .doc(sponsor.id);

      sponsorRef
        .set(sponsor, { merge: true })
        .then(() => {
          this.closePopup();
        })
        .catch((err) => console.log(err));
    },
    deleteSponsor(id) {
      return Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL",
      }).then((result) => {
        if (result.value) {
          return db
            .collection("event")
            .doc(this.$route.params.id)
            .collection("sponsors")
            .doc(id)
            .delete();
        }
      });
    },
    editSponsor(item) {
      this.sponsor = JSON.parse(Object.assign(JSON.stringify(item)));
      this.sponsor.id = item.id;
      this.showPopup = true;
      this.init_edit = true;
    },
  },
  watch: {
    showPopup() {
      if (!this.showPopup) {
        this.currentSponsor = null;
      }
    },
  },
};
</script>

<style lang="scss">
.sponsors {
  display: flex;
  justify-content: flex-start;
  .card {
    width: 32%;
    text-align: center;
    margin-right: 1%;

    .image {
      height: 150px;
      background-size: cover;
      background-position: center center;
      width: 100%;
    }

    p {
      margin: 0;
    }

    .name {
      font-weight: bold;
      margin-top: 20px;
    }

    .title {
      border-bottom: none;
    }

    .description {
      margin-top: 15px;
      font-size: 14px;
    }
  }
}
</style>
